// extracted by mini-css-extract-plugin
module.exports = {"container":"landing_container__1h8t-","logo":"landing_logo__3em4z","landingImg":"landing_landingImg__241Yu"};